import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import axiosRetry from "axios-retry";
import dayjs from "dayjs";
import dayjsPluginUTC from "dayjs/plugin/utc";

import { RootState, store } from "../store/store";
import {
  clearAccessToken,
  setAccessToken,
} from "../store/modules/auth/authSlice";
import { msalInstance } from "..";
import { loginRequest } from "../authConfig";

dayjs.extend(dayjsPluginUTC);

function getRootState(): RootState {
  return store.getState();
}
declare global {
  interface Window {
    __config: any;
  }
}
export const app_uri: string = window.__config.API_URL;

const axiosClient = (): AxiosInstance => {
  const axiosClient = axios.create();
  axiosRetry(axios, { retries: 1, retryDelay: axiosRetry.exponentialDelay });

  function doConfig(
    config: InternalAxiosRequestConfig
  ): InternalAxiosRequestConfig {
    const state = getRootState();
    const token = state.auth.accessToken;
    const impersonate = state.admin;
    const user = state.user.currentUser;
    config.headers["Content-Type"] =
      config.data instanceof FormData
        ? "multipart/form-data"
        : "application/json";
    config.headers["Authorization"] = "Bearer " + token;
    config.baseURL = app_uri;

    if (
      user?.isAdmin &&
      impersonate.isImpersonating &&
      impersonate.impersonatedUserId
    ) {
      config.headers["X-Impersonate-User"] = state.admin.impersonatedUserId;
    }
    // config.headers["credential"] = "include";
    return config;
  }

  axiosClient.interceptors.request.use((config) =>
    doConfig(config as InternalAxiosRequestConfig)
  );

  axiosClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        if (error.response.status === 401) {
          store.dispatch(clearAccessToken());
          window.location.href = "/login";
        } else if (error.response.status === 403) {
          if (!window.location.pathname.includes("pricing")) {
            console.error("Access forbidden:", error);
            window.location.href = "/pricing";
          }
        }
      }
      return Promise.reject(error);
    }
  );

  // axiosClient.interceptors.response.use(
  //   (response) => response,
  //   async (error) => {
  //     if (error.response && error.response.status === 401) {
  //       try {
  //         // Get the active account
  //         const account = msalInstance.getActiveAccount();

  //         if (account) {
  //           // Attempt to silently acquire a new token
  //           const response = await msalInstance.acquireTokenSilent({
  //             account: account,
  //             scopes: loginRequest.scopes,
  //           });

  //           // Update the token in Redux store
  //           store.dispatch(
  //             setAccessToken({
  //               token: response.accessToken,
  //               expiresIn: response.expiresOn
  //                 ? Math.floor(
  //                     (response.expiresOn.getTime() - Date.now()) / 1000
  //                   )
  //                 : 3600,
  //             })
  //           );

  //           // Retry the original request with the new token
  //           const originalRequest = error.config;
  //           originalRequest.headers[
  //             "Authorization"
  //           ] = `Bearer ${response.accessToken}`;
  //           return axios(originalRequest);
  //         }
  //       } catch (refreshError) {
  //         console.error("Token refresh failed:", refreshError);
  //         // If token refresh fails, clear the token and redirect to login
  //         store.dispatch(clearAccessToken());
  //         window.location.href = "/login";
  //       }
  //     } else if (error.response && error.response.status === 403) {
  //       console.error("Access forbidden:", error);
  //       // window.location.href = "/pricing";
  //     }

  //     return Promise.reject(error);
  //   }
  // );

  return axiosClient;
};

export default axiosClient;
